import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, byteSize, getSortState, openFile } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './device.reducer';

export const Device = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const deviceList = useAppSelector(state => state.device.entities);
  const loading = useAppSelector(state => state.device.loading);
  const totalItems = useAppSelector(state => state.device.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="device-heading"
        headingDataCy="DeviceHeading"
        contentKey="fleetSenseApp.device.home.title"
        buttonTextKey="fleetSenseApp.device.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {deviceList && deviceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <DoNotShowInProduction>
                  <th className="hand" onClick={sort('id')}>
                    <Translate contentKey="fleetSenseApp.device.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                <th className="hand" onClick={sort('deviceType')}>
                  <Translate contentKey="fleetSenseApp.device.deviceType">Device Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('manufacturer')}>
                  <Translate contentKey="fleetSenseApp.device.manufacturer">Manufacturer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('model')}>
                  <Translate contentKey="fleetSenseApp.device.model">Model</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('image')}>
                  <Translate contentKey="fleetSenseApp.device.image">Image</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="fleetSenseApp.device.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {deviceList.map((device, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <DoNotShowInProduction>
                    <td>
                      <Button tag={Link} to={`${match.url}/${device.id}`} color="link" size="sm">
                        {device.id}
                      </Button>
                    </td>
                  </DoNotShowInProduction>
                  <td>
                    <Translate contentKey={`fleetSenseApp.DeviceType.${device.deviceType}`} />
                  </td>
                  <td>{device.manufacturer}</td>
                  <td>{device.model}</td>
                  <td>
                    {device.image ? (
                      <div>
                        {device.imageContentType ? (
                          <a onClick={openFile(device.imageContentType, device.image)}>
                            <img src={`data:${device.imageContentType};base64,${device.image}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {device.imageContentType}, {byteSize(device.image)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{device.description}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${device.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${device.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.device.home.notFound">No Devices found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={deviceList && deviceList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Device;
